import React from 'react';

const Hero = () => {
  return (
    <section className="relative w-full h-[60vh] md:h-[70vh] lg:h-[80vh] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/1232931/pexels-photo-1232931.jpeg?auto=compress&cs=tinysrgb&w=1920"
          alt="Engagement Rings"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/25"></div>
      </div>

      {/* Title Overlay */}
      <div className="absolute inset-0 flex items-center justify-center">
        <h1 
          className="text-white text-5xl md:text-7xl lg:text-[90px] font-light tracking-wide"
          style={{ 
            fontFamily: '"Cormorant Garamond", Georgia, "Times New Roman", serif',
            fontStyle: 'italic',
            fontWeight: 300,
            textShadow: '2px 2px 12px rgba(0,0,0,0.4)'
          }}
        >
          Engagement Rings
        </h1>
      </div>
    </section>
  );
};

export default Hero;
